// eslint-disable-next-line import/prefer-default-export
export const ANALYTICS_EN = {
  // Toltips
  ResetDate: 'Remove Date',

  DataStudio: 'Data studio',
  GeneralAnalytics: 'General analytics',
  DataNPS: 'NPS Analysis',

  // Data Studio
  Active: 'Active',
  Deleted: 'Deleted',
  Paused: 'Paused',
  Closed: 'Closed',
  NamelessVacancy: 'Unnamed vacancy',
  TrafficPerDevice: 'Traffic per devices',
  TrafficPerRegion: 'Traffic per region',
  TrafficPerInstitutes: 'Tráfico por Institutes',
  Mobile: 'Mobile',
  Tablet: 'Tablet',
  Desktop: 'Desktop',
  WhereVisitorsComeFrom: 'Where do your visitors come from?',
  Export: 'Export',
  DetailedView: 'Detailed view',
  Name: 'Name',
  Status: 'Status',
  Date: 'Date',
  ViewsLP: 'Views (LP)',
  ViewsI: 'Views (Institutes)',
  ViewsM: 'Views (Mobile)',
  ViewsT: 'Views (Tablet)',
  ViewsD: 'Views (Desktop)',

  // General Analytics
  VacanciesWithWarning: 'Vacancies - (Do not take in count the selected period)',
  WrongDatesWarning: 'The initial date must be before the final date.',
  Period: 'Period',
  Devices: 'Devices',
  Total: 'Total',
  ActivePlural: 'Active',
  PausedPlural: 'Paused',
  ClosedPlural: 'Closed',
  ClosedSingle: 'Closed',
  Audience: 'Audience',
  TotalVisits: 'Total visits',
  Source: 'Source',
  Institutes: 'Institutes',
  ComingSoon: 'Coming soon!',
  Applicants: 'Candidate',
  Pending: 'Pending',
  InProcess: 'In process',
  Accepted: 'Accepted',
  Rejected: 'Rejected',

  // Single Analytics
  Vacancies: 'Vacancies',
  Vacancy: 'Vacancy:',
  Published: 'Published:',
  Platform: 'Platform:',
  SettleTime: 'Settle time:',
  Visits: 'Visits:',
  days: 'days',
  SingularPending: 'Pending',
  OrganicApplications: 'Organic applications',
  ManualApplications: 'Manual applications',
  TotalApplications: 'Total applications',
  TotalCandidates: 'Total candidates',
  TotalVacancy: 'Total vacancies',
  Applications: 'Applications',
  ConversionRate: 'Conversion rate',
  AverageTimeByState: 'Average time by state (General)',
  GeneralInformationByVacancy: 'General information by vacancy',
  vacanciesDisplay: 'Viewing vacancies',
  morePostulations: 'Vacancies with the most candidates',

  clickApply: 'Click to apply',
  candidateTotal: 'Total candidates',
  pending: 'Pending',
  inprocess: 'In Process',
  accepted: 'Accepted',
  rejected: 'Rejected',
  generalVacancy: 'Average time per phase',

  // Tabla
  vancateTable: 'Vacancy',
  DatePublish: 'Publication date',
  PlacementDate: 'Placement date',
  CandidateAccepted: 'Candidate accepted',
  statusVacancy: 'Vacancy status',
  activeTime: 'Active time',

  mobile: 'Mobile',
  tableta: 'Tablet',
  desktop: 'Desktop',
  views: 'Views',
  state: 'State',
  percentage: 'Percentage',
  respondents: 'Respondents',
  answerRate: 'Answer Rate',
  sended: 'Sended',
  vacanciesWithNPS: 'Vacancies with NPS',
  generalInfo: 'General information',
  abandonmentRate: 'Abandonment rate',
  send: 'Sended',
  answered: 'Answered',
  analiticsNPS: 'Analitics NPS',
  results: 'Results',
  noAnswers: 'There are no info',
  waiting: 'Wait a moment please',
  createReport: 'Creating report',
  download: 'Download',
  updateEvery24: 'This chart is updated every 24 hours.',

  postulationsClic: 'Postulations clicks',
  postulations: 'Postulations',
  postingVacancies: 'Vacancies posting',

  columnName: 'Column name',
  informationPerColumn: 'Average time spent per column',
  sitesViewed: 'User Acquisition Channels',
  ignoreFilters: 'This chart ignore date filters',
};
